<template>
  <!-- 配置账户 -->
  <el-dialog :visible="addBankAccount" width="515px" :title="title" class="addBrand" @close="onClose">
    <el-form
      :model="queryParams"
      ref="queryParamsRefs"
      :rules="queryParamsRules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="23">
          <el-form-item label="账号名称：" prop="accountName">
            <el-input v-model.trim="queryParams.accountName" :disabled="isfrom === 2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="23">
          <el-form-item label="开户行：" prop="bankName">
            <el-input v-model.trim="queryParams.bankName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="23">
          <el-form-item label="银行行号：" prop="bankNumber">
            <el-input v-model.trim="queryParams.bankNumber"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="23">
          <el-form-item label="银行账号：" prop="bankAccount">
            <el-input v-model.trim="queryParams.bankAccount"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit(queryParams)">确 定</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  updateEnterPrise,
  addEnterPrise
} from '@/api/system/rightsManagement'
export default {
  data () {
    return {
      isfrom: 0,
      editparams: {},
      addBankAccount: false,
      // 添加物流信息
      queryParams: {
        accountName: '', // 账号名称
        bankName: '', // 开户行
        bankAccount: '' // 银行账号
      },
      type: 1,
      title: '',
      queryParamsRules: {
        accountName: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 新增物流信息
    onInitialize (type, row) {
      this.isfrom = type
      // type=1为新增账户,type=2为更改账户
      if (type === 1) {
        this.title = '账户信息'

        this.queryParams = {
          accountName: '', // 账号名称
          bankName: '', // 开户行
          bankAccount: '' // 银行账号
        }
      } else {
        this.title = '配置账户'
        this.editparams = row
        const { bankCode, bankUserName, bankOpenName, bankNumber } = row
        this.queryParams = {
          bankAccount: bankCode,
          accountName: bankUserName,
          bankName: bankOpenName,
          bankNumber: bankNumber
        }
      }
      this.addBankAccount = true
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          if (this.isfrom === 1) {
            const { accountName, bankName, bankAccount, bankNumber } = this.queryParams

            this.editparams.bankCode = bankAccount
            this.editparams.bankOpenName = bankName
            this.editparams.bankUserName = accountName
            this.editparams.bankNumber = bankNumber
            addEnterPrise(this.editparams).then(ree => {
              let isflag = true
              if (ree.data.code !== 200) {
                isflag = false
                this.addBankAccount = true
              } else {
                this.addBankAccount = false
              }

              this.$message({
                message: ree.data.msg,
                type: ree.data.code === 200 ? 'success' : 'error'
              })

              this.$parent.getInit()
            })
          } else {
            const { bankAccount, accountName, bankName, bankNumber } = this.queryParams
            this.editparams.bankCode = bankAccount
            this.editparams.bankUserName = accountName
            this.editparams.bankOpenName = bankName
            this.editparams.bankNumber = bankNumber
            updateEnterPrise(this.editparams).then((v, i) => {
              this.$message({
                message: v.data.msg,
                type: v.data.code === 200 ? 'success' : 'error'
              })
            })
          }
          this.addBankAccount = false
        } else {
          return false
        }
      })
    },
    // 取消关闭弹窗
    onClose () {
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
      this.addBankAccount = false
    }
  }
}
</script>

<style>
</style>
